import cn from 'classnames'
import useNavigation from 'core/hooks/useNavigation'
import Icon from 'core/components/icons/Icon'
import { createBrowserHistory } from 'history'

export interface BackNavLinkProps {
  to: string
  className?: string
  shouldReplace?: boolean
  overrideHistory?: boolean
}

const history = createBrowserHistory()

const BackNavLink = ({
  to,
  className,
  shouldReplace,
  overrideHistory = false
}: BackNavLinkProps) => {
  const { push, replace } = useNavigation()
  return (
    <div
      onClick={() => {
        if (window.history.length > 2 && !overrideHistory) {
          return history.back()
        }

        if (shouldReplace) {
          return replace(to)
        }
        push(to)
      }}
      role="navigation"
      data-title="back-button"
      className={cn([
        'cursor-pointer text-dark-4 text-md hover:text-primary whitespace-nowrap',
        className
      ])}
    >
      <Icon name="arrow-left" className="mr-1 mb-1" size={14} noWrapper />
      Back
    </div>
  )
}

export default BackNavLink
